import type {
  ChatAutoAssignmentResponse,
  MerchantSettings,
  UserApplicableSettings,
  UserSettings,
} from '@reducers/chatAutoAssignment';
import type { Selector } from '@types';

export const allDepartmentsSettings: Selector<
  ChatAutoAssignmentResponse[]
> = state => state.adminHome.chatAutoAssignment?.departmentSettings;

export const allDepartmentsSettingsLoading: Selector<boolean> = state =>
  state.adminHome.chatAutoAssignment?.loading.includes(
    'get-all-department-settings'
  );

export const changeDeparmentStatusLoading: Selector<boolean> = state =>
  state.adminHome.chatAutoAssignment?.loading.includes('change-state');

export const merchantSettings: Selector<MerchantSettings> = state =>
  state.adminHome.chatAutoAssignment?.merchantSettings;

export const userSettings: Selector<UserSettings> = state =>
  state.adminHome.chatAutoAssignment.userSettings;

export const showWarningTraysOnHold: Selector<boolean> = state => {
  const { userApplicableSettings: settings } =
    state.adminHome.chatAutoAssignment;
  return !settings?.allowTakingChatsManually;
};

export const getUserApplicableSettings: Selector<
  UserApplicableSettings
> = state => state.adminHome.chatAutoAssignment?.userApplicableSettings;
export default allDepartmentsSettings;
